export default "/images/silent-hill-baddie.png";